import NextLink from 'next/link';

import Box from 'shopper/components/Box';
import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import Image from 'components/Image';

import placeholder from 'lib/placeholder';

import APP from 'constants/app';
import LINKS from 'constants/links';

const EmptyMyOffersList = () => (
  <Box>
    <div className="flex h-[500px] flex-col items-center justify-center">
      <Image
        alt="Carrinho de compras"
        height={84}
        loading={null}
        src={`${APP.LOCAL_IMAGE_PATH}/features/my-offers/embedded-shopping-cart.svg`}
        width={84}
        priority
      />
      <Heading as="h2" className="mt-4" size="size5">
        {placeholder('empty.myOffers')}
      </Heading>
      <Text className="my-4 max-w-112 text-center">
        {placeholder('descriptions.foundGoodPromotion')}
      </Text>
      <NextLink href={LINKS.NEW_OFFER} prefetch={false} passHref>
        <Button as="a">{placeholder('actions.suggestOffer')}</Button>
      </NextLink>
    </div>
  </Box>
);

export default EmptyMyOffersList;
